import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class FhProductStockInfo extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateStockInfo);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateStockInfo);
  }

  /**
   * Updates the stock info when variant changes.
   * @param {import('@theme/events').VariantUpdateEvent} event - The variant update event.
   */
  updateStockInfo = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newStockInfo = event.detail.data.html.querySelector('fh-product-stock-info');

    if (!newStockInfo) return;

    morph(this, newStockInfo, { childrenOnly: true });
  };
}

if (!customElements.get('fh-product-stock-info')) {
  customElements.define('fh-product-stock-info', FhProductStockInfo);
}
